import { deepmerge } from '@mui/utils';
import {
  defaultDarkTheme,
  defaultTheme,
} from "react-admin";

declare module '@mui/material/styles' {
  interface TypeBackground {
    overlay: string;
  }
}

const baseMyThemeLight = {
  palette: {
    primary: {
      main: "#1976d2",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2196f3",
      contrastText: "#fff",
    },
    background: {
      default: "#f4f6f8", // a light grey for the overall app background
      paper: "#ffffff", // for cards and panels
      overlay: "rgba(255, 255, 255, 0.85)", // semi-transparent surface for overlays on backgrounds
    },
    error: {
      main: "#f44336",
    },
    success: {
      main: "#4caf50",
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
    h6: {
      fontWeight: 500,
    },
    // You can customize other typography variants as needed
  },
  shape: {
    borderRadius: 8, // more modern, rounded corners
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // disables all-uppercase styling
          boxShadow: "none",
          borderRadius: 8,
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
      },
    },
    // RaMenu: {
    //   styleOverrides: {
    //     root: {
    //       '& .RaMenu-open': {
    //         width: 240,
    //       },
    //       '& .RaMenu-closed': {
    //         width: 50,
    //       },
    //     },
    //   },
    // },
    // Additional overrides for react-admin components (e.g., DataGrid, AppBar) can be added here
  },
  // sidebar: {
  //   width: 240,
  //   closedWidth: 50,
  // },
};

const baseMyThemeDark = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#ededed', // grupo agape... o original é #90caf9 - grupo agape #ededed
    },
    background: {
      overlay: "rgba(0, 0, 0, 0.5)",
    },
  },
};

export const myThemeLight = deepmerge(defaultTheme, baseMyThemeLight);
export const myThemeDark = deepmerge(defaultDarkTheme, baseMyThemeDark);